import { render, staticRenderFns } from "./BasicComponent.vue?vue&type=template&id=0d49bdcd&scoped=true"
import script from "./BasicComponent.vue?vue&type=script&lang=js"
export * from "./BasicComponent.vue?vue&type=script&lang=js"
import style0 from "./BasicComponent.vue?vue&type=style&index=0&id=0d49bdcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d49bdcd",
  null
  
)

export default component.exports